import { ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import { BackButtonIconEnum } from '../PageHeader/types';
import { CloseButtonAlignType } from '../Modal/types';

export enum SelectHorizontalAlignmentEnum {
  Left = 'left',
  Right = 'right'
}

export interface SelectProps {
  value?: string | ReactNode;
  placeholder: string | ReactNode;
  children: ReactNode;
  cypress: string;
  width: number | string;
  stat?: string;
  ariaLabel?: string;
  horizontalAlign?: SelectHorizontalAlignmentEnum;
  showIcon?: boolean;
  styles?: RuleSet<object>;
  onClose?: () => void;
  onOpenChange?: (isOpen: boolean) => void;
  modalTitle?: string | ReactNode;
  isPlaceholderVisible?: boolean;
  valueTag?: string;
  showModalHeaderBorder?: boolean;
  popoverStyles?: RuleSet<object>;
  stylesModal?: RuleSet<object>;
  closeIcon?: BackButtonIconEnum;
  closeButtonAlign?: CloseButtonAlignType;
  input?: ReactNode;
  error?: boolean | string;
  modalCypress?: string;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  isWithHover?: boolean;
}

export interface SelectContainerProps {
  $hasValue?: boolean;
  $styles?: RuleSet<object>;
  $isSelected?: boolean;
  $isError: boolean;
  $isWithHover: boolean;
}
